module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "url('../../../static/search/roomTopBg.png')",
      "max-width": "7.5rem",
      "height": "0.7rem",
      "width": "100%",
      "z-index": "11"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "0.3rem 0.1rem 0.1rem 0.3rem",
      "height": "0.7rem",
      "position": "fixed",
      "z-index": "12"
    },
    attrs: {
      "src": require("../../../static/home/Brand/GoBackCircle.png")
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "13.3rem"
    },
    attrs: {
      "src": _vm.$route.query.iframePage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.1rem"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c9e16b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/OtherPage.vue
// module id = 1495
// module chunks = 18